import { Pipe, PipeTransform } from '@angular/core';
import {PreisPipe} from './preis.pipe';

@Pipe({
  name: 'namePreis'
})
export class NamePreisPipe implements PipeTransform {
  constructor(private preisPipe: PreisPipe) {}

  transform(value: any, args?: any): any {
    if (!value) {
      return null;
    }
    if (!value.preis) {
      return value.name;
    }
    return value.name + ': ' + this.preisPipe.transform(value.preis);
  }
}
